/**
 * Gateway API
 * Gateway API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';


import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';

export enum ActivityTypeEnum {
    LOGIN = 'LOGIN',
    LOGOUT = 'LOGOUT'
}

@Injectable()
export class GatewayUserActivityService {

    protected basePath = 'https://dmp.airiane.com/services/gateway';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();


    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Log action
     * Permet de logger une activité
     * @param activityType type ActivityTypeEnum
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public logCustomActivity(activityType: ActivityTypeEnum, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public logCustomActivity(activityType: ActivityTypeEnum, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public logCustomActivity(activityType: ActivityTypeEnum, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public logCustomActivity(activityType: ActivityTypeEnum, observe: any = 'body', reportProgress = false): Observable<any> {

        if (activityType === null || activityType === undefined) {
            throw new Error('Required parameter activityType was null or undefined when calling logCustomActivity.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (activityType !== undefined && activityType !== null) {
            queryParameters = queryParameters.set('activityType', activityType as never);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<any>('post', `${this.basePath}/api/activities/log`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
